import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Feature, SubscriptionProduct } from '../../common/pricing/subscription-product';

@Component({
    selector: 'app-pricing-block',
    templateUrl: './pricing-block.component.html',
    styleUrls: ['./pricing-block.component.scss']
})
export class PricingBlockComponent {

    @Input() public subscriptionProduct: SubscriptionProduct;
    @Input() public showSignupButton = true;
    // eslint-disable-next-line no-magic-numbers
    @Input() public cardMinimumHeightPx = 600;

    constructor(private readonly router: Router) {
    }

    public signUpClicked(isPlanner: boolean) {
        this.router.navigate(['/signup', {isPlanner}]);
    }

    public getFeatureInnerText(feature: Feature) {
        return feature.shortDescription + (feature.isPending ? ' <sup>Coming Soon!</sup>' : '');
    }

}
